import humps from "humps";
import { getField, updateField } from "vuex-map-fields";
import { forEach } from "lodash-es";

const queryString = require("query-string");
const localStorageSearchHistory = localStorage.getItem("hungryhub_search_history");

function mergeCustomSearch(params) {
  const currentSearch = queryString.parse(window.location.search);
  const newParams = params;
  if (typeof currentSearch.restaurant_group !== "undefined") {
    newParams.restaurant_group = currentSearch.restaurant_group;
  }
  return newParams;
}

const defaultState = () => {
  const currentSearch = humps.camelizeKeys(queryString.parse(window.location.search));
  const { branchId, dineIn, delivery } = currentSearch;

  let isDelivery = true;
  let isDineIn = true;

  if (dineIn) {
    isDelivery = false
    isDineIn = true
  }

  if (delivery) {
    isDelivery = true
    isDineIn = false
  }

  return {
    branchId: branchId,
    adult: 2,
    cuisine: "",
    cuisines: [],
    date: "",
    filters: {},
    groupTags: "",
    hashtags: "",
    isBigGroupBooking: "",
    kids: 0,
    location: "",
    locations: [],
    name: "",
    price: "",
    showFilterScreen: "",
    sortBy: "",
    startTime: "",
    customSearchId: null,
    isDelivery,
    isDineIn
  };
};

export default {
  namespaced: true,
  state: {
    searchHistory: localStorageSearchHistory ? JSON.parse(localStorageSearchHistory) : [],
    ...defaultState()
  },
  getters: {
    getField,
    // we don't stringify this payload to make it usable in another components
    searchPayload(state) {
      const {
        branchId,
        adult,
        cuisines,
        cuisine,
        date,
        groupTags,
        hashtags,
        kids,
        location,
        locations,
        name,
        price,
        sortBy,
        startTime,
        customSearchId,
        isDelivery,
        isDineIn
      } = state;
      const params = humps.decamelizeKeys({
        branchId,
        adult,
        cuisines,
        cuisine,
        date,
        groupTags,
        hashtags,
        kids,
        location,
        locations,
        name,
        price,
        sortBy,
        startTime,
        customSearchId,
        isDelivery,
        isDineIn
      });

      return mergeCustomSearch(params);
    },
    searchRouteJsonPath(state, getters, rootState, rootGetters) {
      const params = queryString.stringify(getters.searchPayload, {
        arrayFormat: "bracket"
      });
      return `/${rootGetters.config.locale}/restaurants/search.json?${params}`;
    },
    searchRouteHtmlPath(state, getters, rootState, rootGetters) {
      const params = queryString.stringify(getters.searchPayload, {
        arrayFormat: "bracket"
      });
      return `/${rootGetters.config.locale}/restaurants/search.html?${params}`;
    }
  },
  mutations: {
    updateField,
    setState(state, payload) {
      state[payload.name] = payload.value;
    },
    setStateProperty(state, payload) {
      state[payload.name][payload.property] = payload.value;
    },
    pushStateItem(state, payload) {
      state[payload.name].push(payload.value);
    }
  },
  actions: {
    initFormValue(context) {
      let listData;
      let listFilters = [];
      if (window.data) {
        const { data } = window;
        listData = [
          {
            name: "name",
            value: data.defaultName
          },
          {
            name: "adult",
            value: data.defaultAdult
          },
          {
            name: "startTime",
            value: data.defaultStartTime
          },
          {
            name: "kids",
            value: data.defaultKids
          },
          {
            name: "groupTags",
            value: data.selectedGroupTags
          },
          {
            name: "price",
            value: data.selectedPrice
          },
          {
            name: "locations",
            value: data.selectedLocations
          },
          {
            name: "cuisines",
            value: data.selectedCuisines
          },
          {
            name: "isBigGroupBooking",
            value: data.isBigGroupBooking
          },
          {
            name: "customSearchId",
            value: data.customSearchId
          }
        ];
      }
      if (window.filters) {
        const { filters } = window;
        filters.locationClosed = true;
        filters.cuisineClosed = true;
        if (filters.sortedBy) {
          listFilters.push({
            name: "sortBy",
            value: filters.sortedBy
          });
        }
        listFilters.push({
          name: "filters",
          value: filters
        });
      }
      const commitArray = [...listFilters, ...listData];
      commitArray.forEach(item => {
        context.commit("setState", {
          name: item.name,
          value: item.value
        });
      });
    },
    updateAndSubmit(context, payload) {
      context.commit("setState", {
        name: payload.key,
        value: payload.value
      });
      context.dispatch("submitFilter");
    },
    submitFilter(context) {
      setTimeout(() => {
        window.location.href = context.getters.searchRouteHtmlPath;
      }, 200);
    },
    clearFilter(context) {
      const newState = defaultState();
      forEach(newState, (value, name) => {
        context.commit("setState", {
          name: name,
          value: value
        });
      });
      context.dispatch("submitFilter");
    },
    sortRestaurantBy(context, payload) {
      context.commit("setState", {
        name: "sortBy",
        value: payload.key
      });
      context.dispatch("submitFilter");
    },
    addSearchHistory(context, payload) {
      const history = context.state.searchHistory;
      const val = payload.value.trim();
      if (history.length > 0) {
        const checkDuplicate = history.filter((storage) => {
          return storage.trim().toLowerCase() == val.toLowerCase()
        })
        if (checkDuplicate.length == 0) {
          context.commit("pushStateItem", {
            name: 'searchHistory',
            value: val
          })
          localStorage.setItem('hungryhub_search_history', JSON.stringify(history));
        }
      }
      else {
        context.commit("pushStateItem", {
          name: 'searchHistory',
          value: val
        })
        localStorage.setItem('hungryhub_search_history', JSON.stringify(history));
      }
    },
    removeSearchHistory(context, payload) {
      const history = context.state.searchHistory;
      const indexToRemove = history.indexOf(payload.value);
      if (indexToRemove > -1) {
        history.splice(indexToRemove, 1)
      }
      localStorage.setItem('hungryhub_search_history', JSON.stringify(history));
    }
  }
};
